
    var riot = require('riot')
    //src: starling/src/tags/waypoints-tab-menu.html
riot.tag2('waypoints-tab-menu',
  '<ul class="floating-menu_list"> <li class="floating-menu_item {waypointsZeroState && \'floating-menu_item--disabled\'}" onclick="{sharePresentation}" data-track="Waypoints-Tab" data-track-action="Share-Presentation" data-track-label="Presentation"> <svg class="floating-menu_icon"> <use xlink:href="#share-icon"></use> </svg> <span class="floating-menu_label">Share presentation</span> </li> <li class="floating-menu_divider"></li> <li class="floating-menu_item {waypointsZeroState && \'floating-menu_item--disabled\'}" onclick="{startPresentation}" data-track="Waypoints-Tab" data-track-action="Start-Presentation" data-track-label="Presentation"> <svg class="floating-menu_icon"> <use xlink:href="#play-circle-filled-icon"></use> </svg> <span class="floating-menu_label">Start presentation</span> <span class="floating-menu_shortcut" if="{this.isMac}">⇧⌘↵</span> <span class="floating-menu_shortcut" if="{!this.isMac}">⌃⇧f5</span> </li> <li class="hidden floating-menu_item {waypointsZeroState && \'floating-menu_item--disabled\'}" ref="resumeButton" onclick="{resumePresentation}"> <svg class="floating-menu_icon"> <use xlink:href="#redo-icon"></use> </svg> <span class="floating-menu_label">Resume presentation</span> <span class="floating-menu_shortcut" if="{this.isMac}">⌘↵</span> <span class="floating-menu_shortcut" if="{!this.isMac}">⌃f5</span> </li> <li class="floating-menu_divider"></li> <li ref="clearWaypoints" class="floating-menu_item {waypointsZeroState && \'floating-menu_item--disabled\'}" onclick="{clearWaypoints}" data-track="Waypoints-Tab" data-track-action="Clear-Waypoints" data-track-label="Waypoints"> <svg class="floating-menu_icon"> <use xlink:href="#delete-icon"></use> </svg> <span class="floating-menu_label">Delete all waypoints</span> </li> </ul>',
  '',
  'class="floating-menu floating-menu--hidden"', function(opts) {
'use strict';

var _this = this;

var _waypointsUi = require('lib/waypoints-ui');

var _waypointsUi2 = _interopRequireDefault(_waypointsUi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _opts = opts,
    canvas = _opts.canvas;
var isMac = canvas.isMac;

this.isMac = isMac;
var waypoints = _waypointsUi2.default.getWaypoints();

canvas.waypointsTabMenu = this;

this.waypointsZeroState = waypoints.length === 0;

this.on('update', function () {
  _this.waypointsZeroState = _waypointsUi2.default.getWaypoints().length === 0;
});

this.startPresentation = function () {
  return canvas.waypointsTabTag.startPresentation();
};

this.resumePresentation = function () {
  return canvas.waypointsTabTag.resumePresentation();
};

this.clearWaypoints = function () {
  return canvas.waypointsTabTag.clearWaypoints();
};

this.sharePresentation = function () {
  var shareModal = canvas.shareModal;

  shareModal.show();
  shareModal.setOpenTab('share-presentation');
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('waypoints-tab-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/waypoints-tab-menu.html
// module id = 666
// module chunks = 0